import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_EMPLOYEES = `${API_URL}/adminWeb/employees`;
const ADD_EMPLOYEE_DETAILS = `${API_URL}/adminWeb/employee/`;
const UPDATE_EMPLOYEE_DETAILS = `${API_URL}/adminWeb/employee/`
export const getEmployees = createAsyncThunk(
  "getEmployees",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '', sortOrder = 'date' } = values
      const { data } = await axios.get(`${GET_ALL_EMPLOYEES}?page=${page}&limit=${limit}&search=${search}&sortOrder=${sortOrder}`, {});      
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "updateEmployee",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${ADD_EMPLOYEE_DETAILS}${values.id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getEmployees({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addEmployee = createAsyncThunk(
  "addEmployee",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${UPDATE_EMPLOYEE_DETAILS}`, values);      
      notify(data.responseMessage, 'success');
      dispatch(getEmployees({ page: values.selectedPage || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "deleteEmployee",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${UPDATE_EMPLOYEE_DETAILS}${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getEmployees({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
